import React, { useEffect, useRef, useState } from "react"
import styles from "./filing.module.css"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../app/store"
import { getSJWHTokenAsync } from "../dataMaintenance/organization/data"
import { unwrapResult } from "@reduxjs/toolkit"
import { useLocation } from "react-router-dom"
import { TcmPastingDetail } from "./TcmPasting/PastingDetail"
import { FillingType } from "./fileUploadService"
import { TcmSpecialDetail } from "./TcmSpecial/SpecialDetail"
import { selectTenantCityCode } from "../../app/applicationSlice"
import { KJYWDetail } from "./AntimicrobialDrugs/KJYWDetail"
import { TraditionalDetail } from "./TraditionalMedicine/TraditionalDetail"
import { FreeMediaDetail } from "./FreeMedica/FreeMediaDetail"
import { ReplaceMakeDetail } from "./ReplaceMake/ReplaceMakeDetail"
import { SSJSSDetail } from "./SurgicalCatalog/SSJSSDetail"

export const FilingManagementDetail = () => {
  const dispatch = useDispatch<RootDispatch>()

  const location: any = useLocation()

  const cityCode = useSelector(selectTenantCityCode)

  return (
    <div className={styles.container}>
      {location.state.type == FillingType.YZBA ? (
        <FreeMediaDetail />
      ) : location.state.type == FillingType.ZYTF ? (
        <TcmPastingDetail />
      ) : location.state.type == FillingType.DJDP ? (
        <ReplaceMakeDetail />
      ) : location.state.type == FillingType.ZYTSLF ? (
        <TcmSpecialDetail />
      ) : location.state.type == FillingType.KJYW ? (
        <KJYWDetail />
      ) : location.state.type == FillingType.CTYX ? (
        <TraditionalDetail />
      ) : location.state.type == FillingType.SSJSS ? (
        <SSJSSDetail />
      ) : (
        ""
      )}
    </div>
  )
}
